<div class="scrollable-quicksearch--wrapper scrollable-quicksearch--has-no-filter-btn">
  <mat-form-field class="no-label infinite-scroll-search mb-0"
                  [ngClass]="{'loading': loading}">
    <mat-icon matIconPrefix
              fontSet="far fa-fw"
              fontIcon="fa-magnifying-glass"
              class="color--gray--007"
              *ngIf="!loading"></mat-icon>
    <mat-icon matIconPrefix
              fontSet="far fa-fw"
              fontIcon="fa-spinner"
              class="color--gray--007 fa-spin"
              *ngIf="loading"></mat-icon>
    <input matInput
           placeholder="{{searchPlaceholder || 'Search...'}}"
           appAutofocus
           #searchElement="autofocus"
           [formControl]="filterInput"
           (keydown.arrowdown)="onSearchArrowDown()"
           name="graphql-search"
           autocomplete="off">
  </mat-form-field>
  <section (keydown)="onResultsListKeydown($event)"
           tabindex="0">
    <cdk-virtual-scroll-viewport #scrollContainer
                                 class="scrollable-quicksearch__results"
                                 [itemSize]="itemSize || 62"
                                 minBufferPx="250"
                                 maxBufferPx="400"
                                 [ngStyle]="{'height':results.length >= maxItemsInScroller ? '250px' : results.length * itemSize + 'px'}"
                                 style="height:250px">
      <!--
                                  [style.minHeight]="isAdvancedResponseSelector ? '250px' : 0"
                                  [ngStyle]="{'height':results.length >= maxListItemsInScroller ? '250px' : results.length * listItemSize + 'px'}" -->
      <ng-container *cdkVirtualFor="let item of results">

        <app-list-item [item]="item"
                       (click)="itemClicked(item)"
                       class="app-list-item c-pointer">

          <!-- Custom template rendered here
                       should have structural directive
                      <span *resultTmpl="let item = item">{{item.name}}</span>
                  -->

          <ng-container *ngTemplateOutlet="resultTemplate; context: { item: item }">
          </ng-container>

        </app-list-item>

      </ng-container>
    </cdk-virtual-scroll-viewport>

    <!-- Custom template rendered here
      for no results, otherwise default is used
      should have structural directive *noResultsTmpl
      -->
    <ng-container *ngIf="results.length === 0">

      <ng-container *ngIf="noResultsTemplate">
        <ng-container *ngTemplateOutlet="noResultsTemplate">
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!noResultsTemplate">
        <div class="result p-0100 flexJustify--between flexWrap--nowrap color--gray">
          <i class="fal fa-spinner-third fa-spin mr-0050"
             *ngIf="initLoading"></i>
          <span *ngIf="!initLoading">No Results</span>
        </div>

      </ng-container>


    </ng-container>

  </section>
</div>
